import {FirebaseApp} from 'firebase/app'
import {collection, deleteDoc, Firestore, getDocs, getFirestore, query, where} from 'firebase/firestore'
import {map} from 'lodash'
import {FirestoreOrg} from '@/types/FirestoreOrg'
import {FirestoreCollections} from '@/types/FirestoreCollections'

let firestore: Firestore

const userOrgsPath = (userId: string) => `${FirestoreCollections.users}/${userId}/${FirestoreCollections.organizations}`

const init = (app: FirebaseApp) => {
    firestore = getFirestore(app)

    // @ts-ignore
    if (window.Cypress) {
        // @ts-ignore
        window.cleanupFbStorage = (userId: string, orgNo: string) => deleteOrg(userId, orgNo)
    }
}

const findOrgs = async (userId: string): Promise<FirestoreOrg[] | []> => {
    try {
        const orgCollectionReference = collection(firestore, userOrgsPath(userId))

        const orgSnapshot = await getDocs(orgCollectionReference)

        const orgs: FirestoreOrg[] = map(orgSnapshot.docs, (doc: any) => ({...doc.data(), id: doc.id}))

        if (!orgs || !orgs.length) return []

        return orgs
    } catch (error: any) {
        console.error('get orgs error: ', error)
        return []
    }
}

const deleteOrg = async (userId: string, orgNo: string): Promise<void> => {
    try {
        const q = query(
            collection(firestore, userOrgsPath(userId)),
            where('organizationNumber', '==', orgNo)
        )

        const querySnapshot = await getDocs(q)

        if (!querySnapshot.empty) {
            const doc = querySnapshot.docs[0].ref
            await deleteDoc(doc)

        }
    } catch (error: any) {
        console.error('delete org error: ', error)
    }
}

const useFirestoreService = () => {
    return {
        init,
        findOrgs,
    }
}

export {
    useFirestoreService,
}